export const appConstants = {
  mainAppBarHeight: 64,
  userDrawerWidth: 300,
  dateFormat: "YYYY-MM-DD",
  hourTimeFormat: "HH:mm",
}
